import { Component } from "@angular/core";

@Component({
  selector: "data-privacy-section-1",
  styleUrls: ["data-privacy-section-1.component.scss"],
  template: `
    <div class="mt-3">
      <h3 class="text-center">{{ "portal.dataPrivacy.1.title" | translate }}</h3>
      <div class="text-center">
        {{ "portal.dataPrivacy.1.subTitle" | translate }}
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <div [innerHTML]="'portal.dataPrivacy.1.1.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.1.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.1.1_1.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.1.1_1.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.1.1_2.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.1.1_2.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.1.1_3.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.1.1_3.text' | translate"></div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <div [innerHTML]="'portal.dataPrivacy.1.2.title' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_1.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_1.text' | translate"></div>
          <h5 class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_2.title' | translate"></h5>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_2.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_3.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_3.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_4.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_4.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_5.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_5.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_6.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_6.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_7.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_7.text' | translate"></div>
          <div class="mt-3" [innerHTML]="'portal.dataPrivacy.1.2.2_8.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.2.2_8.text' | translate"></div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <div [innerHTML]="'portal.dataPrivacy.1.3.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.3.text' | translate"></div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-12">
          <div [innerHTML]="'portal.dataPrivacy.1.4.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.4.text' | translate"></div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <div [innerHTML]="'portal.dataPrivacy.1.5.title' | translate"></div>
          <div [innerHTML]="'portal.dataPrivacy.1.5.text' | translate"></div>
        </div>
      </div>
    </div>
  `,
  standalone: false,
})
export class DataPrivacySection1Component {
  constructor() {}
}
